import { render, staticRenderFns } from "./BlacklistActions.vue?vue&type=template&id=5c545240"
import script from "./BlacklistActions.vue?vue&type=script&lang=js"
export * from "./BlacklistActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports